import styled from 'styled-components';
import { palette } from 'styled-tools';

import { CalmLogoColor, maxWidth, minWidth } from '@calm-web/design-system';

import RawCalmLogo from '@/components/CalmLogo';

export const Wrapper = styled.header<{ $isSticky: boolean }>`
	background-color: ${palette('white')};
	border-bottom: 1px solid ${palette('gray2')};
	position: ${p => (p.$isSticky ? 'sticky' : 'static')};
	top: 0;
	width: 100%;
	z-index: 1;
	isolation: isolate;
	padding: 0 16px;
	${minWidth('tablet')} {
		padding: 0 75px;
	}
`;
export const Content = styled.div`
	display: flex;
	flex-direction: row;
	padding: 8px 0;
	justify-content: space-between;
	align-items: center;
	margin: auto;
	max-width: 600px;
	min-height: 63px;
	${minWidth('tablet')} {
		max-width: 1164px;
		padding: 8px 0;
		height: 80px;
	}
`;
export const CalmLogo = styled(RawCalmLogo).attrs({
	color: CalmLogoColor.Gradient,
})`
	${maxWidth('tablet')} {
		width: 64px;
		// This line is just for maintaining vertical centering.
		height: 25px;
	}
`;
